import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

import './ClientesSlider.css';

// 🔥 LOGOS REALES
import corrugados from '../assets/images/corrugados.png';
import cypr from '../assets/images/cypr.png';
import latin from '../assets/images/latin.png';
import pnacionales from '../assets/images/pnacionales.png';
import propelco from '../assets/images/propelco.png';

export default function ClientesSlider() {

  const clientes = [
    { img: corrugados, nombre: 'Corrugados' },
    { img: cypr, nombre: 'CYPR' },
    { img: latin, nombre: 'Latin' },
    { img: pnacionales, nombre: 'P. Nacionales' },
    { img: propelco, nombre: 'Propelco' }
  ];

  return (
    <section className="clientes">

      <Swiper
        modules={[Autoplay]}
        slidesPerView={4}
        spaceBetween={20}
        loop={true}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        speed={3000}
        breakpoints={{
          320: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 }
        }}
      >
        {clientes.map((c, i) => (
          <SwiperSlide key={i}>
            <div className="cliente-card">
              <img src={c.img} alt={c.nombre} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}